import MiniLinePlot from '../mini-line-plot/mini-line-plot.component';
import MiniBarPlot from '../mini-bar-plot/mini-bar-plot.component';
import MiniEmbeddingsPlot from '../mini-embeddings-plot/mini-embeddings-plot.component';
import { Group } from '@visx/group';
import { Text } from '@visx/text';
import { useMantineTheme } from '@mantine/core';

const marginForEachSideDataPlot = 5;
const marginForEachSideEmbeddingsPlot = 8;
const smallPlotDimensions = 100;

const MiniPlot = ({
    dimensions,
    embeddingData,
    selectedEmbeddingIndex,
    similarQuestionData,
    isShowingTSNE,
    shownQuestionIndices
}) => {

    const theme = useMantineTheme();

    const miniPlotTop = dimensions.margins.top + 10;
    const miniPlotLeft = dimensions.margins.left + dimensions.innerWidth - (smallPlotDimensions + 10);
    
    return (
        <svg 
            style={{ 
                    display: 'block',
                    position: 'absolute',
                    top: miniPlotTop,
                    left: miniPlotLeft,
                    pointerEvents: 'none'
                }}
            width={smallPlotDimensions}
            height={smallPlotDimensions}
        >
            <Group>
                <rect
                    width={smallPlotDimensions}
                    height={smallPlotDimensions}
                    fill='#ffffff'
                    rx={theme.radius.md}
                    ry={theme.radius.md}
                    // Background opacity
                    fillOpacity={0.85}
                    // Background blur
                    // filter='blur(10px)'
                    // stroke={theme.colors.gray[6]}
                />
                {
                    isShowingTSNE ?
                        <MiniEmbeddingsPlot
                            embeddingData={embeddingData}
                            plotHeight={smallPlotDimensions}
                            plotWidth={smallPlotDimensions}
                            selectedEmbeddingIndex={selectedEmbeddingIndex}
                            marginForEachSide={marginForEachSideEmbeddingsPlot}
                            shownQuestionIndices = {shownQuestionIndices}
                        />
                        :
                        selectedEmbeddingIndex !== null && selectedEmbeddingIndex >= 0 ?
                            similarQuestionData[selectedEmbeddingIndex].length > 1 ?
                                <MiniLinePlot
                                    plotHeight={smallPlotDimensions}
                                    plotWidth={smallPlotDimensions}
                                    marginForEachSide={marginForEachSideDataPlot}
                                    yearData={similarQuestionData[selectedEmbeddingIndex]}
                                />
                                :
                                <MiniBarPlot
                                    plotHeight={smallPlotDimensions}
                                    plotWidth={smallPlotDimensions}
                                    marginForEachSide={marginForEachSideDataPlot}
                                    yearData={similarQuestionData[selectedEmbeddingIndex]}
                                />
                            :
                            <>
                                <Group top={smallPlotDimensions / 2} left={smallPlotDimensions / 2} style={{ pointerEvents: 'none' }}>
                                    <Text
                                        textAnchor="middle"
                                        verticalAnchor="middle"
                                        fontSize='14px'
                                        fill={theme.colors.gray[6]}
                                    >
                                        Raw data
                                    </Text>
                                </Group>
                            </>
                }
            </Group>
        </svg>)
}

export default MiniPlot;